module.exports = __webpack_public_path__ + "static/img/74dc2b38f772ebfef1d7aacd6cb350f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/page-resource/global/img/account/ic-yixinli-logo.png
// module id = xVr7
// module chunks = 0